import { ApiGetRequest, ICounterParty } from 'types';

import { EPaymentMethod, IForwardShorten, IGoCertificateShorten } from 'modules/eecs-go';
import { EWalletNetwork } from 'modules/wallet';

export enum EEecsPackageDeliveryDeadline {
  ONE_DAY = '1',
  TWO_DAYS = '2',
  THREE_DAYS = '3',
  FOUR_DAYS = '4',
  FIVE_DAYS = '5',
  SIX_DAYS = '6',
  ONE_WEEK = '7',
  TWO_WEEKS = '14',
}

export enum EEecsPackageModals {
  ADD = 'add',
  DETAILS = 'details',
  CONFIRM = 'confirm',
  CONFIRM_FREE = 'confirm_free',
}

export enum EEecsPackageModalAction {
  ADD = 'add',
  DELETE = 'delete',
  REJECT = 'reject',
  ACCEPT = 'accept',
  CONFIRM = 'confirm',
}

export enum EEecsBuyerState {
  REJECT = 'declined',
  ACCEPT = 'accepted',
}

export enum EEecsPackageType {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing',
}

export enum EEecsPackageStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  NO_PAYMENT = 'no_payment',
  CANCELLED = 'cancelled',
  DELIVERED = 'delivered',
}

export interface IEecsPackage {
  id: number;
  rdid: string | null;
  type: EEecsPackageType;
  status: EEecsPackageStatus;
  price: number;
  counter_party?: ICounterParty;
  forwards: IForwardShorten[];
  certificates: IGoCertificateShorten[];
  cancellation_reason: string[];
  seller_company_id: number;
  payment_method: EPaymentMethod | null;
  wallet_blockchain: EWalletNetwork | null;
  stripe_payment_id: string | null;
  wallet_txn_hash: string | null;
  wallet_fee_txn_hash: string | null;
  recs_url: string | null;
  bid_id?: string;
  is_free: boolean;
  created_at: string;
  need_confirm_payment_by_seller: boolean | null;
  seller_company_uuid: string | null;
}
export interface PackageForwardItem {
  id: number;
  volume: number;
  _selected_volume?: number;
}

export interface EecsPackageModalPayload {
  action?: EEecsPackageModalAction;
}

export interface IEecsPackageModal {
  type: EEecsPackageModals;
  payload?: EecsPackageModalPayload;
}

export interface FetchPackagesPayload extends ApiGetRequest {
  filter_by_creation_start_date?: string | null;
  filter_by_creation_end_date?: string | null;
  filter_by_energy_source?: string | null;
  filter_by_type_of_installation?: string | null;
  filter_by_counter_party_necs_account_id?: string | null;
  filter_by_contents?: string | null;
  filter_by_type?: string | null;
  filter_by_status?: string | null;

  order_by_price?: 'asc' | 'desc';
  order_by_counter_party_company_name?: 'asc' | 'desc';
  order_by_type?: 'asc' | 'desc';
  order_by_contents?: 'asc' | 'desc';
}

export interface AddPackagePayload {
  company_id: number | null;
  price: number;
  is_free: boolean;
  deadline_days: number;
  certificates?: {
    group_id: string;
    volume: number;
  }[];
  forwards?: PackageForwardItem[];
}

export interface UpdatePackagePayload {
  id: number;
  buyer_status?: EEecsBuyerState;
  seller_status?: EEecsPackageStatus.CANCELLED;
}

export interface ConfirmEecsPackagePaymentPayload {
  id: number | string;
  type: 'fee' | 'order';
}
